var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturedActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 512,
    viewBox: "0 0 384 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32C32 14.3 46.3 0 64 0H320C337.7 0 352 14.3 352 32C352 49.7 337.7 64 320 64H290.5L301.9 212.2C338.6 232.1 367.6 265.4 381.4 306.9L382.4 309.9C385.7 319.7 384 330.4 378 338.7C372 347 362.3 352 352 352H32C21.7 352 12.1 347.1 6.00004 338.7C-0.0999637 330.3 -1.69996 319.6 1.60004 309.9L2.60004 306.9C16.4 265.4 45.4 232.1 82.1 212.2L93.5 64H64C46.3 64 32 49.7 32 32ZM160 384H224V480C224 497.7 209.7 512 192 512C174.3 512 160 497.7 160 480V384Z",
    fill: "#0494FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedActive);
export default __webpack_public_path__ + "static/media/featuredActive.115a69434c09bd97ca0e80cdb183023b.svg";
export { ForwardRef as ReactComponent };